import { useMemo } from 'react';
import { ReactEditor, useSlate } from 'slate-react';

export const useSelectionDomRange = () => {
  const editor = useSlate(); // get the "active" instance, that changes with selection

  return useMemo(() => {
    const currentSelection = editor.selection || editor.getPreviousSelection();
    if (!currentSelection) {
      return null;
    }

    if (!ReactEditor.hasRange(editor, currentSelection)) {
      return null;
    }

    return ReactEditor.toDOMRange(editor, currentSelection);
  }, [editor]);
};
